import React from 'react';
import { useParams } from 'react-router-dom';
import { useGetProjectByIdQuery } from 'src/services';
import { ToolTip } from 'src/components/ToolTip/ToolTip';
import { clsx } from 'clsx';
import { useAppSelector } from 'src/store';

const STATUSES_TYPES = {
  launch: {
    title: 'Launched',
    label: 'The AI model is launched',
    textColor: '#389D61',
    bgColor: '#DCF8E4',
  },
  demo: {
    title: 'Demo',
    label: 'The project is in demo mode',
    textColor: '#009CB2',
    bgColor: '#DBF3FA',
  },
  notLaunched: {
    title: 'Not launched',
    label: 'The AI model has not been launched yet',
    textColor: '#05050D80',
    bgColor: '#E5ECEB',
  },
  paused: {
    title: 'Paused',
    label: 'Rate limit reached',
    textColor: '#C97902',
    bgColor: '#F5ECDB',
  },
  disabled: {
    title: 'Disabled',
    label: 'The project has been manually disabled',
    textColor: '#C11A45',
    bgColor: '#F0E2E6',
  },
  draft: { title: 'Draft', label: 'Draft', textColor: '#7A6BE5', bgColor: '#EDEBFF' },
};

export const ProjectStatusBadge = ({ project = undefined }: { project?: any } = {}) => {
  const { id } = useParams();

  const { data: currentProject } = useGetProjectByIdQuery({ id: id }, { skip: !id });

  const { isInactivePlan } = useAppSelector((s) => s.planSlice);

  const projectData = currentProject || project;

  const projectStatus = () => {
    if (
      Boolean(projectData?.is_active && projectData?.integrations?.length) &&
      !projectData?.is_demo_mode &&
      !isInactivePlan
    ) {
      return STATUSES_TYPES.launch;
    }
    if (projectData?.is_demo_mode && !isInactivePlan) {
      return STATUSES_TYPES.demo;
    }
    if (!projectData?.is_active || isInactivePlan) {
      return STATUSES_TYPES.disabled;
    }
    return STATUSES_TYPES.notLaunched;
  };

  return (
    <div>
      <ToolTip
        side={'top'}
        trigger={
          <div
            style={{ background: projectStatus().bgColor }}
            className={clsx('py-[5px] px-3 w-fit rounded-full flex gap-1 items-center')}
          >
            <p
              style={{ color: projectStatus().textColor }}
              className="text-[0.625rem] font-medium capitalize"
            >
              {projectStatus().title}
            </p>
          </div>
        }
        content={
          <p className="font-medium font-jamjuree text-xs text-ebony opacity-50">
            {projectStatus().label}
          </p>
        }
      />
    </div>
  );
};
